import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/join1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/join2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/join3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/join4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/join5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/join6.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/join/page.module.css");
